import React from 'react';
import { Modal, Box /*, Typography, IconButton, Paper*/ } from '@mui/material';
import useSimulationStore from '../../store/simulationStore';
import ReactionEditorLine from './ReactionEditorLine';

const ReactionEditorPanel: React.FC = () => {
  // Get state and actions from the store
  const editingReactionId = useSimulationStore(state => state.editingReactionId);
  const stopEditingReaction = useSimulationStore(state => state.stopEditingReaction);
  const reaction = useSimulationStore(state => 
    state.controls.reactions.find(r => r.id === editingReactionId)
  );

  const handleClose = () => {
    stopEditingReaction();
  };

  const isOpen = editingReactionId !== null;
  const reactionName = reaction?.name || 'Reaction';

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="reaction-editor-title"
      disableAutoFocus
      disableEnforceFocus
    >
      <div style={modalStyle}>
        <div style={headerStyle}>
          <h2 id="reaction-editor-title" style={titleStyle}>
            Edit: {reactionName}
          </h2>
          <button onClick={handleClose} style={closeButtonStyle}>
            &times;
          </button>
        </div>

        {editingReactionId && reaction ? (
          <ReactionEditorLine 
            key={editingReactionId}
            reactionId={editingReactionId} 
            onClose={handleClose} 
          />
        ) : (
          <p style={{ color: 'red' }}>Error: Selected reaction data not available.</p>
        )}
      </div>
    </Modal>
  );
};

const modalStyle: React.CSSProperties = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  maxWidth: '80vw',
  backgroundColor: '#333',
  border: '2px solid #000',
  boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
  padding: '16px',
  color: '#fff'
};

const headerStyle: React.CSSProperties = {
  display: 'flex', 
  justifyContent: 'space-between', 
  alignItems: 'center', 
  marginBottom: '8px'
};

const titleStyle: React.CSSProperties = {
    margin: 0, 
    fontSize: '1.5rem'
};

const closeButtonStyle: React.CSSProperties = {
    background: 'none',
    border: 'none',
    color: 'inherit',
    fontSize: '1.5rem',
    cursor: 'pointer',
    padding: '0 4px'
};

export default ReactionEditorPanel; 